export class CopyLink {
    constructor(optionalOptions = {}) {
        this._copies = document.querySelectorAll('[data-action="copy-link"]');

        if (!this._copies) {
            this.destructor();
            return true;
        }

        this._copies.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault()

                if (button.dataset.href) {
                    window.copyTextToClipboard(button.dataset.href);
                    window.closeAllModals();
                    window.showModal('modal-user-gallery-photo-copy-link-success')
                }

                return false
            })
        })
    }

    destructor() {
        this._copies = null;
    }
}

export default new CopyLink();